import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DateRangeService } from '../../../core/services/date-range.service';
import { HistoryPagedResponse } from '../models/rma.model';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private readonly http = inject(HttpClient);
  private readonly dateRangeService = inject(DateRangeService);
  private baseUrl = environment.apiBaseUrl;

  /**
   * Get history logs with pagination and filtering
   * Endpoint: GET /api/History
   */
  getHistoryLogs(
    dateFrom?: Date,
    dateTo?: Date,
    claimId?: number,
    claimLineId?: number,
    eventType?: number,
    page: number = 1,
    pageSize: number = 50
  ): Observable<HistoryPagedResponse> {
    let params = new HttpParams()
      .set('Page', page.toString())
      .set('PageSize', pageSize.toString());

    if (dateFrom) {
      const utcFrom = this.dateRangeService.toUtcDateFrom(dateFrom);
      if (utcFrom) {
        params = params.set('DateFrom', utcFrom);
      }
    }

    if (dateTo) {
      const utcTo = this.dateRangeService.toUtcDateTo(dateTo);
      if (utcTo) {
        params = params.set('DateTo', utcTo);
      }
    }

    if (claimId !== undefined && claimId !== null) {
      params = params.set('ClaimId', claimId.toString());
    }

    if (claimLineId !== undefined && claimLineId !== null) {
      params = params.set('ClaimLineId', claimLineId.toString());
    }

    if (eventType !== undefined && eventType !== null) {
      params = params.set('EventType', eventType.toString());
    }

    return this.http.get<HistoryPagedResponse>(`${this.baseUrl}History`, { params });
  }
}
